import React, { useEffect } from "react";

import { get } from "react-hook-form";
import ErrorBlock from "./error";


const SelectableCardList = ({
  name,
  label,
  register,
  setValue,
  error,
  containerClass = "card-template-container",
  cardTemplates,
  registerOptions,
  text,
  setSelectedCardIndex,
  selectedCardIndex,
}) => {

  useEffect(() => {
    if (selectedCardIndex !==null && cardTemplates) {
      setValue(name, cardTemplates[selectedCardIndex].uid);
      setValue("placid_uuid", cardTemplates[selectedCardIndex].placid_uuid);
    }
  }, []);

  const handleCardSelect = (index) => {
    setSelectedCardIndex(index);
    setValue(name, cardTemplates?.[index]?.uid ?? undefined);
    setValue("placid_uuid", cardTemplates?.[index]?.placid_uuid ?? undefined)
  };

  return (
    <div className={`mb-5 ${containerClass} ${cardTemplates.length < 2 ? "display-hidden" : ""}`} >
      {label && <label className="input-label" htmlFor={name}>{label}</label>}
      {text &&
        <p>
          <small className="form-text text-muted">{text}</small>
        </p>
      }
      <div className="card-template-list">
        <input value={selectedCardIndex !== null && cardTemplates ? cardTemplates[selectedCardIndex].uid : undefined} style={{display : "none"}} {...register(name)} />
        {cardTemplates?.map((card, index) => (
          <div
            key={index}
            className={`card-template ${selectedCardIndex === index ? "selected" : ""}`}
            onClick={() => handleCardSelect(index)}
          >
            <img src={card.card_image.url} alt={card.title} />
          </div>
        ))}
      </div>
      {error && <ErrorBlock error={error} />}
    </div >
  )
};

export const renderSelectableCardTemplate = (
  name,
  errors,
  setValue,
  register,
  setSelectedCardIndex,
  selectedCardIndex,
  cardTemplates,
  { label, placeholder, registerOptions, text, containerClass },
) => {

  return (
    <SelectableCardList
      containerClass={containerClass}
      name={name}
      label={label}
      text={text}
      placeholder={placeholder}
      error={get(errors, name)?.message}
      setValue={setValue}
      register={register}
      registerOptions={registerOptions}
      selectedCardIndex={selectedCardIndex}
      cardTemplates={cardTemplates}
      setSelectedCardIndex={setSelectedCardIndex}
    />
  );
};

    SelectableCardList.displayName = "SelectableCardList";

export default SelectableCardList

